import React, { useState, useContext, useEffect } from 'react'
import {
    handleRedirectInternal,
    mapData,
    jsonToFormData,
    currencyFormat,
} from '../../Product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../Product/context/auth/authContext'
import AlertContext from '../../Product/context/alert/alertContext'
import ProductContext from '../../Product/context/product/productContext'
import PluginContext from '../../Product/context/plugin/pluginContext'
import NoRecordsFound from '../../Product/components/atoms/NoRecordsFound'
import Loader from '../../assets/loader'
import moment from 'moment'
import { setRef } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'
import Copy from '../../utils/CommonFunctionality/Share/Copy'

const Referrals = () => {
    const authContext = useContext(AuthContext)
    const productContext = useContext(ProductContext)
    const pluginContext = useContext(PluginContext)
    const validationArray = Yup.object({})
    const [regBtnLoading, setRegBtnLoading] = useState(false)
    const [listLoading, setListLoading] = useState(false)
    const [referralist, setReferralList] = useState([])
    const [referralListCount, setReferralListCount] = useState(0)
    const [page, setPage] = useState(1)

    const { user, loadUser, isAuthenticated, active_plugins, getActivePlugins } = authContext
    const { getReferralHistory, responseStatus, all_referrals, clearResponse } = pluginContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext

    useEffect(() => {
        if (responseStatus && responseStatus !== '') {
            if (responseStatus.from === 'getReferralHistory') {
                // redeemEnablelist({
                //     site_id: global?.storeDetails?.site_id,
                //     user_id: user.id,
                // })
                setListLoading(false)
            }
        }
    }, [responseStatus])
    useEffect(() => {
        if (all_referrals?.message && all_referrals?.message?.results.length > 0) {
            setReferralList(all_referrals?.message?.results)
            setReferralListCount(all_referrals?.message?.results_cnt)
            setListLoading(false)
        } else {
            setListLoading(false)
            setRegBtnLoading(false)
        }
    }, [all_referrals])
    useEffect(() => {
        setListLoading(true)
        const fetchReferralList = async () => {
            if (user) {
                const res = await getReferralHistory({
                    site_id: global?.storeDetails?.site_id,
                    user_id: user.id,
                    invoice_id: '',
                    type: 'referral_code',
                    page: page,
                    perlimit: 10,
                })
            }
        }
        fetchReferralList()
    }, [user, page])

    return (
        <div>
            <h6>
                Your Referral Code : {user?.tw_json} <Copy text={user?.tw_json} textOnly={true} />
            </h6>
            {listLoading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : referralist.length > 0 ? (
                <>
                    <div className="table-responsive mt-4">
                        {
                            <table className="table table-hover mobile-table responisveTable">
                                <thead className="hidden-mobile">
                                    <tr>
                                        {/* <th></th> */}
                                        {/* <th className="numCell" role="id">
                                        Id
                                    </th> */}
                                        <th role="Plan">S.no</th>
                                        <th role="Amount">Date</th>
                                        <th role="Name">Referrer</th>
                                        <th role="Amount">Notes</th>
                                        <th role="Status">Amount</th>
                                        {/* <th role="RedeemDate">Redeem Date</th> */}
                                    </tr>
                                </thead>

                                <tbody>
                                    {referralist.length !== 0 &&
                                        referralist.map((item, index) => {
                                            return (
                                                <>
                                                    {item ? (
                                                        <tr key={index}>
                                                            {/* <td data-label="id">{item.id}</td> */}
                                                            <td
                                                                data-label="S.no"
                                                                className="center"
                                                            >
                                                                {index + 1}
                                                            </td>
                                                            <td
                                                                data-label="Date"
                                                                className="center"
                                                            >
                                                                {moment
                                                                    .utc(
                                                                        item?.date_add,
                                                                        'MM/DD/YYYY hh:mm:ss A',
                                                                    )
                                                                    .local()
                                                                    .format('dddd, MMMM DD, YYYY')}
                                                            </td>
                                                            <td
                                                                data-label="Referrer"
                                                                className="center"
                                                            >
                                                                {item?.refer_name
                                                                    ? item?.refer_name
                                                                    : '-'}
                                                            </td>
                                                            <td
                                                                data-label="Notes"
                                                                className="center"
                                                            >
                                                                {item?.processing_option ==
                                                                'referral_code'
                                                                    ? 'Referral Signup'
                                                                    : 'Referral Bidding'}
                                                            </td>

                                                            <td
                                                                data-label="amount"
                                                                className="center"
                                                            >
                                                                {currencyFormat(item?.amount)}
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </>
                                            )
                                        })}
                                </tbody>
                            </table>
                        }
                    </div>
                    <Pagination
                        count={Math.ceil(referralListCount / 10)}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                    />
                </>
            ) : (
                <NoRecordsFound />
            )}
        </div>
    )
}

export default Referrals
